import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';
import {getCurrentUserName} from "../../services/authService";
import Intercom from 'react-intercom';
import {IntercomAPI} from 'react-intercom';
import RetinaImage from "react-retina-image";

class Navigation extends Component {
    activeRoute = (routeName) => {
        //console.log("this", this);
        //console.log("routeName", routeName);
        if (this.props.location)
            return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
        return "";
    };

    secondLevelActive = (routeName) => {
        return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
    };

    state = {
        user_name: "",
        selected_source_rss: this.props.selected_source_rss,
        selectedSource: this.props.selectedSource,
        source_active: true,
        dropDownRemoved: true,
        selectedSourceName: this.props.selectedSourceName,
        shortenedName: '',
        scrollTop: 0,
        smsInboxEnabled: false,
        user: this.props.user
    };

    componentDidMount = async () => {
        //console.log('navigation selected source: ', this.props.selectedSourceName)
        await this.setState({
            user_name: getCurrentUserName(),
        });
        //console.log('workspaceName: ', this.state.selectedSourceName)
        localStorage.setItem('workspaceName', this.state.selectedSourceName);
        let shortenedName = '';
        if (this.state.selectedSourceName && this.state.selectedSourceName.length > 23) {
            shortenedName = this.state.selectedSourceName.substring(0, 18) + '...'

        }
        if (this.state.user && this.state.user.sources) {
            let selectedSourceFull = await this.state.user.sources.data.filter(
                source => {
                    // //console.log('current source Id : ', source.id)
                    // //console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === this.state.selectedSource.toString()

                }
            )
            let smsInboxEnabled
            if (selectedSourceFull[0]?.use_custom_plan && selectedSourceFull[0].use_custom_plan === 1 && selectedSourceFull[0].custom_plan) {
                smsInboxEnabled = selectedSourceFull[0].custom_plan.additional_features.sms_inbox === 1
            } else {
                if (selectedSourceFull[0]?.plan?.additional_features) {
                    smsInboxEnabled = selectedSourceFull[0].plan.additional_features.sms_inbox === 1
                } else {
                    smsInboxEnabled = false
                }
            }

            this.setState({
                selectedSourceFull,
                smsInboxEnabled
            })
        }
        this.setState({
            shortenedName
        })
    }


    componentDidUpdate = async () => {
        if (this.state.selectedSourceName !== this.props.selectedSourceName) {
            localStorage.setItem('workspaceName', this.props.selectedSourceName);
            //console.log('selectedSourceName: ', this.props.selectedSourceName)
            let shortenedName = this.props.selectedSourceName.substring(0, 18) + '...'
            this.setState({
                selectedSourceName: this.props.selectedSourceName,
                shortenedName
            })
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            //console.log('selectedSourceName: ', this.props.selectedSourceName)

            if (this.state.user && this.state.user.sources) {
                //console.log('user has sources')
                let selectedSourceFull = await this.state.user.sources.data.filter(
                    source => {
                        // //console.log('current source Id : ', source.id)
                        // //console.log('selectedSource id :', this.state.selectedSource);
                        return source.id.toString() === this.props.selectedSource.toString()

                    }
                )
                //console.log('selectedSourceFull: ', selectedSourceFull)
                let smsInboxEnabled
                if (selectedSourceFull[0]) {
                    if (selectedSourceFull[0].use_custom_plan && selectedSourceFull[0].use_custom_plan === 1 && selectedSourceFull[0].custom_plan) {
                        smsInboxEnabled = selectedSourceFull[0].custom_plan.additional_features.sms_inbox === 1
                    } else {
                        if (selectedSourceFull[0] && selectedSourceFull[0].plan && selectedSourceFull[0].plan.additional_features) {
                            smsInboxEnabled = selectedSourceFull[0].plan.additional_features.sms_inbox === 1
                        } else {
                            smsInboxEnabled = false
                        }
                    }
                }
                //console.log('smsInboxEnabled: ', smsInboxEnabled)
                this.setState({
                    selectedSourceFull: selectedSourceFull[0] ? selectedSourceFull : [],
                    smsInboxEnabled: selectedSourceFull[0] ? smsInboxEnabled : this.state.smsInboxEnabled
                })
            }
            await this.setState({
                selectedSource: this.props.selectedSource

            })

        }

    }
    workspaceSelected = (e) => {
        this.props.onClick(e)
        this.props.onClickHam()
    }

    render() {
        let sources = this.props.sources || [];
        let source_name = "";
        let selectedSource = this.state.selectedSource || "";
        let selected_source_rss = this.state.selected_source_rss || "";
        //let feeds_shared = this.props.feeds_shared || [];
        let subscription_renewal_problem = this.props.subscription_renewal_problem;
        //console.log('sources first: ', sources);


        return (

            <div className="side-menu onboarding-tour-step-2 " data-intercom-target="side-menu">
                <div className="fixed-menu">
                    <div className="dash-logo">
                        <Link to="#">
                            <RetinaImage className='dash-logo-img'
                                         src={['/img/emitto-logo-wh.png', '/img/emitto-logo-wh.svg']} alt='Emitto'
                                         checkIfRetinaImgExists={false}
                            />
                        </Link>
                    </div>
                    <div className="projects-section shadow-bottom">
                        <div className="grey-text">
                            Workspaces
                        </div>
                        {sources.length === 0
                            //&& feeds_shared.length === 0
                            ?
                            <button className='btn-transparent create-new-btn onboarding-tour-step-5'
                                    onClick={this.props.addSource}>
                                <span className='fas fa-plus-circle'></span> Create new workspace
                            </button>
                            :
                            <div className="nice-select first-workspace-tour-step-2"
                                 data-intercom-target="navigation-project-select-nice-select"
                                 tabIndex="0">

                                {
                                    this.props.selectedSourceName ?

                                        <div
                                            className="current">{this.props.selectedSourceName.length > 23 ? this.props.selectedSourceName.substring(0, 18) + '...' : this.props.selectedSourceName}</div>
                                        :
                                        <div className="current">No workspaces yet</div>
                                }
                                <ul className="list">
                                    {
                                        sources.length ? sources.map(source => (

                                                <li key={source.id}
                                                    id={source.id}
                                                    onClick={(e) => this.workspaceSelected(e)}
                                                    className={source.id.toString() === selectedSource.toString()
                                                        ?
                                                        (!source.active) ? "option inactive selected focus" :
                                                            "option active selected"
                                                        :
                                                        (!source.active) ? "option inactive" :
                                                            "option"}
                                                    name={source.rss || ""}
                                                    title={source.active ? "active" : "inactive"}>
                                                    {source.name.length > 23 ? source.name.substring(0, 18) + '...' : source.name}
                                                </li>

                                            ))
                                            :
                                            ""
                                    }
                                    {/*{*/}
                                    {/*    feeds_shared.length ? feeds_shared.map(source => (*/}
                                    {/*            <li key={source.project_id}*/}
                                    {/*                id={source.project_id}*/}
                                    {/*                onClick={this.props.onClick}*/}
                                    {/*                className={source.project_id && source.project_id.toString() === selectedSource.toString()*/}
                                    {/*                    ?*/}
                                    {/*                    (!source.active) ? "option inactive selected focus" :*/}
                                    {/*                        "option active selected"*/}
                                    {/*                    :*/}
                                    {/*                    (!source.active) ? "option inactive" :*/}
                                    {/*                        "option"}*/}
                                    {/*                name={source.rss || ""}*/}
                                    {/*                title={source.active ? "active" : "inactive"}>*/}
                                    {/*                {source.name.length > 23 ? source.name.substring(0, 18) + '...' : source.name}*/}
                                    {/*            </li>*/}

                                    {/*        ))*/}
                                    {/*        :*/}
                                    {/*        ""*/}
                                    {/*}*/}
                                    <li>
                                        <button className='btn-transparent' onClick={this.props.addSource}>
                                            <span className='fas fa-plus-circle'></span> Create new workspace
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }
                        {/*<button className='btn-transparent" onClick={this.props.addSource}>*/}
                        {/*    <span className='fas fa-plus-circle'></span> Create new project*/}
                        {/*</button>*/}

                        <ul className='dashboard-menu first-workspace-tour-step-3'>
                            <li className={this.activeRoute("/new")}>
                                <div className="menu-link">
                                    {!subscription_renewal_problem ?
                                        <NavLink
                                            to="/new" style={{
                                            borderLeft: "none",
                                            display: "block"

                                        }}
                                            onClick={this.props.onClickHam}>
                                            <span className='fas fa-bullhorn'></span> New Campaign
                                        </NavLink>
                                        :
                                        <a style={{borderLeft: "none", display: "block"}}
                                           onClick={this.props.onClickHam}>
                                            <span className='fas fa-bullhorn'></span> New Campaign
                                        </a>
                                    }
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>
                <div
                    className={this.props.isShowingTopHeaderCallout ? "dashboard-menu-container more-height" : "dashboard-menu-container"}>
                    <ul className="dashboard-menu">
                        {/*{process.env.REACT_APP_ENVIRONMENT === 'DEV' ?*/}
                        {/*    <li className={this.activeRoute("/dashboard")}>*/}
                        {/*        <div className="menu-link first-workspace-tour-step-4">*/}

                        {/*            {!subscription_renewal_problem ?*/}
                        {/*                <NavLink to="/dashboard"*/}
                        {/*                         style={{borderLeft: "none", display: "block"}}*/}
                        {/*                         onClick={this.props.onClickHam}>*/}
                        {/*                    <span className='fas fa-tachometer-alt'></span> Dashboard*/}
                        {/*                </NavLink>*/}
                        {/*                :*/}
                        {/*                <a style={{borderLeft: "none", display: "block"}}*/}
                        {/*                   onClick={this.props.onClickHam}>*/}
                        {/*                    <span className='fas fa-tachometer-alt'></span> Dashboard*/}
                        {/*                </a>*/}
                        {/*            }*/}
                        {/*        </div>*/}
                        {/*    </li>*/}
                        {/*    : ''}*/}
                        {/*<li className={this.activeRoute("/campaigns")}>*/}
                        {/*    <div className="menu-link">*/}
                        {/*        <NavLink to="/campaigns" style={{borderLeft: "none", display: "block"}}*/}
                        {/*                 onClick={this.props.onClickHam}>*/}
                        {/*            <span className='fas fa-bullhorn'></span> New Campaign*/}
                        {/*        </NavLink>*/}
                        {/*    </div>*/}
                        {/*</li>*/}

                        <li className={this.activeRoute("/my-campaigns")}>
                            <div className="menu-link ">
                                {!subscription_renewal_problem ?
                                    <NavLink className='first-workspace-tour-step-5' to="/my-campaigns"
                                             style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-chart-line'></span> My Campaigns
                                    </NavLink>
                                    :
                                    <a className='first-workspace-tour-step-5'
                                       style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-chart-line'></span> My Campaigns
                                    </a>
                                }
                            </div>
                        </li>
                        <li className={this.activeRoute("/url/shortener") || this.activeRoute("/url/analytics") || this.activeRoute("/url/settings")}>
                            <div className="menu-link first-workspace-tour-step-6">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/url/shortener" style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-link'></span> Url Shortener
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-link'></span> Url Shortener
                                    </a>
                                }
                            </div>
                        </li>
                        {this.state.smsInboxEnabled ?
                            <li className={this.activeRoute("/sms-inbox")}>
                                <div className="menu-link">
                                    {!subscription_renewal_problem ?

                                        <NavLink
                                            to="/sms-inbox" style={{
                                            borderLeft: "none",
                                            display: "block"
                                        }}
                                            onClick={this.props.onClickHam}>
                                            <span className='fas fa-inbox'></span> SMS Inbox
                                        </NavLink>

                                        :

                                        <a
                                            style={{
                                                borderLeft: "none",
                                                display: "block"
                                            }}
                                            onClick={this.props.onClickHam}>
                                            <span className='fas fa-inbox'></span> SMS Inbox
                                        </a>
                                    }
                                </div>
                            </li>
                            : ''
                        }
                        <li className='grey-text'>
                            Audience
                        </li>
                        <li className={this.activeRoute("/subscribers")}>
                            <div className="menu-link first-workspace-tour-step-7">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/subscribers"
                                             style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-users'></span> Subscribers
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-users'></span> Subscribers
                                    </a>
                                }
                            </div>
                        </li>
                        <li className={this.activeRoute("/contacts")}>
                            <div className="menu-link first-workspace-tour-step-8">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/contacts"
                                             style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-address-book'></span> Contacts
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-address-book'></span> Contacts
                                    </a>
                                }
                            </div>
                        </li>

                        <li className='grey-text'>
                            Settings
                        </li>
                        <li className={this.activeRoute("/channels")}>
                            <div className="menu-link first-workspace-tour-step-9">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/channels" style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-share-alt'></span> Channels
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-share-alt'></span> Channels
                                    </a>
                                }
                            </div>
                        </li>
                        <li className={this.activeRoute("/content-automation")}>
                            <div className="menu-link first-workspace-tour-step-10">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/content-automation" style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-magic'></span> Content Automation
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-magic'></span> Content Automation
                                    </a>
                                }
                            </div>
                        </li>

                        <li className={this.activeRoute("/tags")}>
                            <div className="menu-link first-workspace-tour-step-11">

                                {!subscription_renewal_problem ?
                                    <NavLink to="/tags" style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className='fas fa-tags'></span> Manage Tags
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}
                                       onClick={this.props.onClickHam}>
                                        <span className='fas fa-tags'></span> Manage Tags
                                    </a>
                                }
                            </div>
                        </li>
                        <li className={this.activeRoute("/workspace-settings")}>
                            <div className="menu-link first-workspace-tour-step-12">
                                {!subscription_renewal_problem ?
                                    <NavLink to="/workspace-settings" style={{borderLeft: "none", display: "block"}}
                                             onClick={this.props.onClickHam}>
                                        <span className="fas fa-sliders-h"></span> Workspace Settings
                                    </NavLink>
                                    :
                                    <a style={{borderLeft: "none", display: "block"}}>
                                        <span className="fas fa-sliders-h"></span> Workspace Settings
                                    </a>
                                }
                            </div>
                        </li>

                        <li className='grey-text'>
                            Support
                        </li>
                        {/*<li className={this.activeRoute("/knowledge-base")}>*/}
                        {/*    <div className="menu-link">*/}
                        {/*        /!*<NavLink to="/knowledge-base" style={{borderLeft: "none", display: "block"}}*!/*/}
                        {/*        /!*onClick={this.props.onClickHam}>*!/*/}
                        {/*        /!*<span className='fas fa-book'></span> Knowledge Base*!/*/}
                        {/*        /!*</NavLink>*!/*/}
                        {/*        <a target='_blank' href="https://help.emitto.io/"*/}
                        {/*           style={{borderLeft: "none", display: "block"}}>*/}
                        {/*            <span className='fas fa-book'></span> Knowledge Base*/}
                        {/*        </a>*/}
                        {/*    </div>*/}
                        {/*</li>*/}
                        <li>
                            <div className="menu-link">
                                <a href="#"
                                   onClick={() => IntercomAPI('showNewMessage', 'Hi team, I am contacting you regarding ')}
                                   id='contact_support_modal'
                                   style={{borderLeft: "none", display: "block"}}
                                >
                                    <span className='fas fa-headset'></span> Contact Support
                                </a>
                            </div>
                        </li>
                        <li className='credits'>
                            Developed by <a target="_blank" rel="noopener noreferrer"
                                            href="https://producthive.io"><span>Product Hive</span></a>
                        </li>
                    </ul>

                </div>
            </div>
        )
    }
}

export default Navigation;